export default {
    login: {
        title: "계정 로그인",
        loadingText: "접속 중",
        form: {
            email: {
                message: "메일주소를 입력하세요",
                placeholder: "메일주소"
            },
            password: {
                message: "비밀번호를 입력하세요",
                placeholder: "비밀번호"
            },
            button: {
                forgotPassword: "비밀번호 찾기",
                login: "로그인",
                otherLogin: "로그인"
            }
        },
        methods: {
            loginMessage: "로그인 성공"
        }
    },
    findPassword: {
        form: {
            email: {
                message: "메일주소를 입력하세요",
                placeholder: "메일주소"
            },
            verificationCode: {
                message: "인증번호를 입력하세요",
                placeholder: "인증번호를 입력하세요",
                loadingText: "로드 중"
            },
            button: {
                verificationCode: "인증번호",
                findPassword: "비밀번호 찾기",
                goLogin: "리턴"
            }
        }
    },
}